/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Invite_Emailstepdescription13Inputs */

const en_usermanagement_invite_emailstepdescription13 = /** @type {(inputs: Usermanagement_Invite_Emailstepdescription13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the email address of the user you want to invite and choose the role they should have`)
};

/**
* | output |
* | --- |
* | "Enter the email address of the user you want to invite and choose the role they should have" |
*
* @param {Usermanagement_Invite_Emailstepdescription13Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_invite_emailstepdescription13 = /** @type {((inputs?: Usermanagement_Invite_Emailstepdescription13Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Invite_Emailstepdescription13Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_invite_emailstepdescription13(inputs)
});
export { usermanagement_invite_emailstepdescription13 as "userManagement_invite_emailStepDescription1" }